export class StaticMemory {
  public static xRoute = '&T(%^&IYU6756856iyku,gKYUGL>IUH' + window.location.hostname;
  public static isAuthVerified: boolean = false;
  public static isServiceArea: boolean = false;
  public static addressObject: any = {};
  public static serAreaObject: any = {};
  public static businessProfileObject: any = {};
  public static walletBalance: number = 0;
  public static menuHidden: boolean = false;
  public static profileDetails: any = {}
}
